import { render, staticRenderFns } from "./FlussiFatturaAnticipataListComponent.vue?vue&type=template&id=b99705b2"
import script from "./FlussiFatturaAnticipataListComponent.vue?vue&type=script&lang=js"
export * from "./FlussiFatturaAnticipataListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports